import storeModule from '../../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'leads-receptions-dashboard-qualified-unqualified-leads',
  storeModule.createStoreModule('leads-receptions-dashboard-qualified-unqualified-leads', {
    fetchListURL: 'leads-receptions/dashboard/qualified-unqualified-leads'
  })
)
